import { Helmet } from 'react-helmet';
import { getImageUrl } from '@/utils/images';
import { InsightCategoryType, InsightGroup } from '@/queries/insights';
import { useLocalization } from '@/hooks/use-localization';
import { useMemo } from 'react';

export const InsightsMeta = ({
    page,
    currentTerm,
    group = 'private',
}: {
    page: number;
    currentTerm?: InsightCategoryType | null;
    group: InsightGroup;
}) => {
    const { localize } = useLocalization();

    const currentTitle = (meta = false) => {
        const parts = [];

        let title = currentTerm ? (meta ? currentTerm.meta_title || currentTerm.title : currentTerm.title) : localize(`${group}`);
        if (page > 1) {
            title += `, ${localize('page', true).toLocaleLowerCase()} ${page}`;
        }
        parts.push(title);

        if (currentTerm) {
            parts.push(localize(`${group}`));
        }

        parts.push('Resurs Insights');

        return parts.join(' - ');
    };

    const currentDescription = useMemo(() => {
        if (!currentTerm) {
            return '';
        }

        const description = currentTerm?.meta_description || currentTerm?.description;
        if (description && page > 1) {
            return `${description} ${localize('page', true)} ${page}`;
        }

        return description;
    }, [currentTerm, page]);

    return (
        <Helmet>
            <title>{currentTitle()}</title>
            <meta name="title" content={currentTitle(!!currentTerm)} />
            <meta property="og:title" content={currentTitle(!!currentTerm)} />

            {currentDescription ? <meta name="description" content={currentDescription} /> : null}
            {currentDescription ? <meta property="og:description" content={currentDescription} /> : null}
            {currentTerm?.featured_image?.src && <meta property="og:image" content={getImageUrl(currentTerm?.featured_image?.src)} />}
        </Helmet>
    );
};
